export default "__VITE_ASSET__DZAzRIEo__"